import _UsageItem from './model';
import create from './create';

const UsageItem = _UsageItem;
UsageItem.create = create;

export default UsageItem;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/onlineUsage/index.js